import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcAfter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.33203 10.832L9.20703 6.4987L4.33203 2.16536",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIcAfter;
